import { Autocomplete, TextField } from "@mui/material";
import { useEffect } from "react";
import { useMotivoDemissaoStore } from "../../stores/rh/motivoDemissao";


interface Props {
  value: number | null
  onChange: (value: number | null) => void
  required?: boolean
  erro?: boolean
  messageErro?: string
  disabled?: boolean
  onOpen?: () => void
}

function MotivoDemissaoSelect({ value, onChange, required = false, erro = false, messageErro = "", disabled = false, onOpen }: Props) {
  const { motivoDemissaoResume, setMotivoDemissaoResume, loadingMotivoDemissaoResume, erroMotivoDemissaoResume, setErroMotivoDemissaoResume } = useMotivoDemissaoStore()

  useEffect(() => {
    if (motivoDemissaoResume.length === 0) {
      setMotivoDemissaoResume()
    }
  }, [])

  return (
    <Autocomplete
      id="demissao-select"
      disabled={disabled}
      options={motivoDemissaoResume}
      onOpen={async () => {
        if (onOpen) {
          onOpen()
        }
        if (motivoDemissaoResume.length === 0) {
          await setMotivoDemissaoResume()
        }
        else {
          setErroMotivoDemissaoResume(false)
        }
      }}
      value={value != null ? motivoDemissaoResume.find((option) => option.idMotivoDemissao == value) : null}
      getOptionLabel={(option) => option.descricaoMotivo ?? "-"}
      onChange={(event, newValue) => {
        onChange(newValue?.idMotivoDemissao ?? null)
      }}
      isOptionEqualToValue={(option, selectedOption) => option.idMotivoDemissao === selectedOption.idMotivoDemissao}
      getOptionKey={(x) => x.idMotivoDemissao}
      filterSelectedOptions
      loading={loadingMotivoDemissaoResume}
      renderInput={(params) => (
        <TextField
          {...params}
          required={required}
          disabled={disabled}
          size="small"
          label="Motivo da demissão"
          error={erroMotivoDemissaoResume || erro}
          helperText={erroMotivoDemissaoResume == true ? "Houve algum erro ao buscar os motivos de demissão" : (erro == true ? messageErro : "")}
        />
      )}
    />
  );
}

export default MotivoDemissaoSelect;